function renderComponentOptions(stepEl, products) {
        const ul = stepEl.querySelector('ul');
        if (!ul) return;
        ul.innerHTML = '';
        const frag = document.createDocumentFragment();

        (products || []).forEach((p, idx) => {
            const li = document.createElement('li');
            li.className = CLASSES.li + (idx === 0 ? ' first' : '');

            const opt = document.createElement('div');
            opt.className = CLASSES.option;
            opt.dataset.componentId = String(stepEl.dataset.item_id);
            opt.dataset.productId = String(p.product_id);

            const hasVariations = Boolean(p.is_variable) && Array.isArray(p.variations) && p.variations.length > 0;
            const selectHtml = hasVariations
                ? `<div style="margin-top:8px">
           <select class="wccp-variation-select" data-component-id="${stepEl.dataset.item_id}" data-product-id="${p.product_id}">
             <option value="">— Select Variation —</option>
             ${(p.variations || []).map(v => `
               <option value="${Number(v.variation_id)}">${variationLabel(v.attributes)}</option>
             `).join('')}
           </select>
         </div>`
                : '';

            const labelsHtml = Array.isArray(p.labels) && p.labels.length
                ? `<div class="wccp-labels-wrap">
                ${p.labels
                    .filter(l => l.enabled)
                    .sort((a, b) => a.priority - b.priority)
                    .map(l => `
                        <span class="wccp-label" style="background:${l.bg};color:${l.fg}">
                            ${l.icon ? `<img src="${l.icon}" alt="" width="14" height="14" style="vertical-align:middle;margin-right:4px;">` : ''}
                            ${l.title}
                        </span>
                    `)
                    .join('')}
              </div>`
                : '';

            opt.innerHTML = `
            ${labelsHtml}
            <div class="${CLASSES.imgWrap}">
                <img src="${p.thumbnail_url || p.thumb || ''}" width="300" height="300" loading="lazy" decoding="async" alt="${(p.name||'').replace(/"/g,'&quot;')}">
            </div>
            <div class="${CLASSES.nameWrap}">
                <span>${p.name || ''}</span>
               
                ${selectHtml}
            </div>
        `;

            li.appendChild(opt);
            frag.appendChild(li);
        });

        ul.appendChild(frag);

        qsa('.wccp-variation-select', stepEl).forEach(autoSelectSingleVariation);

        bindStepClicksFor(stepEl);
        applyPreselectForComponent(stepEl);

        /*** DEBUG ***/
        // window.afterWccpStepDomRender();

    }